import React from "react";
import styled from "styled-components";
// Assets
import QuoteIcon from "../../assets/svg/Quotes";

export default function TestimonialBox({ text, author, rating }) {
  return (
    <Wrapper className="flexNullCenter flexColumn">
      <QuoteWrapper>
        <QuoteIcon />
      </QuoteWrapper>
      <p className="whiteColor font13" style={{ paddingBottom: "30px" }}>
        {text}
      </p>
      <StarsWrapper>
        {[...Array(5)].map((_, index) => (
          <i key={index} className={`fas fa-star star-filled`} />
        ))}
      </StarsWrapper>
      <AuthorWrapper
        className="font13"
        style={{ color: "red", fontWeight: "bold", alignSelf: "flex-end" }}
      >
        <em>{author}</em>
      </AuthorWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  padding: 20px 30px;
  margin-top: 30px;
  background-color: rgb(
    255,
    123,
    0
  ); // Adjust background color to match dark theme
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
`;

const QuoteWrapper = styled.div`
  position: relative;
  top: -40px;
`;

const StarsWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px 0;

  .star-filled {
    color: #ffd700; // Gold color for filled stars
  }

  .star-empty {
    color: #d3d3d3; // Gray color for empty stars
  }
`;

const AuthorWrapper = styled.p`
  padding-top: 15px;
  font-style: italic;
`;
